/*
 * @Description: 导出chart配置
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-19 16:16:04
 * @LastEditTime: 2020-10-14 16:39:41
 */

import valueTrend from './valueTrend';
import KOL from './KOL';
import wordOfMouth from './wordOfMouth';
import emotionalTendencyPolar from './emotionalTendencyPolar';
import emotionalTendencyBar from './emotionalTendencyBar';
import brandValueBar from './brandValueBar';
import brandValueLine from './brandValueLine';
import shareOfMind from './shareOfMind';
import shareOfMindSingle from './shareOfMindSingle';
import competingGoods from './competingGoods';
import competingGoodsLine from './competingGoodsLine';
import favorComplate from './favorComplate';
import favorComplatePolar from './favorComplatePolar';
import competingGoodsLegend from './competingGoodsLegend';
import industryContent from './industryContent';
import fiveFavor from './fiveFavor';
import wordOfMouthContrast from './wordOfMouthContrast';
import _shareOfMind from './_shareOfMind';
import chartPie from './chartPie';
import _KOL from './_KOL';
import _emotionalTendencyPolar from './_emotionalTendencyPolar';
import multiaxis from './multiaxis';
import multiaxisD3 from './multiaxisD3';
import wordcloud from './wordcloud';
import gutt from './gutt';

export {
  valueTrend,
  KOL,
  wordOfMouth,
  emotionalTendencyPolar,
  emotionalTendencyBar,
  brandValueLine,
  brandValueBar,
  shareOfMind,
  shareOfMindSingle,
  competingGoods,
  competingGoodsLine,
  favorComplate,
  favorComplatePolar,
  competingGoodsLegend,

  industryContent,
  fiveFavor,
  wordOfMouthContrast,
  _shareOfMind,
  chartPie,
  _KOL,
  _emotionalTendencyPolar,
  multiaxis,
  multiaxisD3,
  wordcloud,
  gutt
};



// WEBPACK FOOTER //
// src/chart/index.js